var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z",
    stroke: "#EAECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3092 15.9391C30.0175 15.9545 30.7299 15.9078 31.4354 15.9633C32.1499 16.0966 32.3221 17.1782 31.6873 17.5325C31.2542 17.7659 30.7397 17.6194 30.2702 17.6606H29.3092V15.9391ZM31.845 13.9905C32.0024 14.546 31.4669 15.0448 30.9319 14.9683H29.3092C29.3206 14.4444 29.2869 13.8758 29.3257 13.3796C29.9757 13.3979 30.6318 13.3422 31.2781 13.4087C31.5557 13.4784 31.7881 13.7067 31.845 13.9905ZM35.7502 5.75272C35.7804 6.81358 35.7546 7.9305 35.7632 9.01287C35.7612 13.4134 35.7675 17.8138 35.7598 22.2146C35.7313 23.8638 34.2697 25.2968 32.6319 25.3297C30.9926 25.3364 29.3529 25.3308 27.7133 25.3326V18.6799C29.4997 18.6707 31.2871 18.6986 33.0728 18.666C33.9012 18.614 34.8085 18.0674 34.8471 17.1558C34.9446 16.2402 34.0814 15.6069 33.2619 15.5069C32.9469 15.4987 32.9561 15.4151 33.2619 15.3786C34.0436 15.2097 34.6574 14.4007 34.4274 13.5905C34.2314 12.7383 33.2896 12.4085 32.5061 12.4101C30.9088 12.3993 29.3111 12.4086 27.7137 12.4055C27.724 11.1635 27.6922 9.92018 27.7308 8.67912C27.8574 7.05968 29.3558 5.72417 30.9705 5.75315C32.564 5.75291 34.1572 5.75291 35.7502 5.75285V5.75272Z",
    fill: "url(#paint0_linear_1_4211)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.662 8.84678C9.70279 7.20019 11.1706 5.77891 12.8063 5.75484C14.4396 5.74981 16.0732 5.75411 17.7065 5.75266C17.702 11.2618 17.7153 16.7716 17.6998 22.2804C17.6369 23.907 16.185 25.3012 14.5672 25.33C12.9308 25.3359 11.2942 25.3308 9.65769 25.3325V18.4555C11.2472 18.831 12.9141 18.9909 14.5358 18.7418C15.5051 18.5858 16.5656 18.1098 16.8938 17.1042C17.1353 16.244 16.9993 15.3386 17.0353 14.4558V12.4054H14.2289C14.2163 13.7615 14.2547 15.1199 14.2086 16.4743C14.133 17.3068 13.3085 17.8358 12.5233 17.8075C11.5496 17.8178 9.61999 17.1018 9.61999 17.1018C9.61514 14.5611 9.64824 11.3793 9.662 8.84702V8.84678Z",
    fill: "url(#paint1_linear_1_4211)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7531 13.2325C18.6054 13.2639 18.7234 12.7294 18.6857 12.5266C18.6957 11.2446 18.6646 9.96112 18.7028 8.67999C18.829 7.0537 20.3389 5.71486 21.9602 5.75293H26.7348C26.7304 11.2621 26.7436 16.7718 26.7281 22.2807C26.6651 23.9073 25.2132 25.3014 23.5953 25.3302C21.9588 25.3364 20.3222 25.3312 18.6856 25.3328V17.7981C19.8033 18.7152 21.3224 18.858 22.7149 18.8604C23.7646 18.8601 24.8083 18.6982 25.8277 18.4561V17.0758C24.6789 17.6484 23.3283 18.0121 22.0548 17.6831C21.1664 17.462 20.5215 16.6034 20.5359 15.6866C20.4329 14.7331 20.9918 13.7265 21.9288 13.4431C23.092 13.0789 24.3599 13.3574 25.4503 13.8309C25.6839 13.9532 25.9211 14.1049 25.8277 13.7144V12.6295C24.004 12.1956 22.0631 12.0359 20.231 12.5079C19.7006 12.6575 19.1839 12.8844 18.7531 13.2327V13.2325Z",
    fill: "url(#paint2_linear_1_4211)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4211",
    x1: 27.6584,
    y1: 15.124,
    x2: 35.7125,
    y2: 15.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4211",
    x1: 9.48644,
    y1: 15.7301,
    x2: 17.5745,
    y2: 15.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4211",
    x1: 18.6738,
    y1: 15.3139,
    x2: 26.7333,
    y2: 15.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.041bc882d9244ce2da2bf357bee87f87.svg";
export { ForwardRef as ReactComponent };